import { useModal } from 'mui-modal-provider';

import { VideoDialog } from 'components/video';

export const useSecurityDemoVideoDialog = () => {
  const { showModal } = useModal();

  return {
    openSecurityDemoVideoDialog: () => {
      showModal(VideoDialog, {
        video: '/assets/video/security-demo.mp4',
        testId: 'security-video',
      });
    },
  };
};
